import React from 'react';
import { useTranslation } from 'react-i18next';
import HeaderWeb from '../layout/HeaderWeb';
import noServiceImage from '../../assets/images/no-service.png';

const NoService = () => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderWeb title={t('service_not_available')} />
      <div className="no-service-section">
        <img src={noServiceImage} alt="" className="no-service-img img-fluid" />
        <p className="no-service-title">{t('service_not_available')}</p>
        <p className="no-service-description">{t('service_not_available_description')}</p>
        <a className="confirm-btn no-service-btn" href="https://vuz.com">
          {t('go_to_vuz')}
        </a>
      </div>
    </>
  );
};

export default NoService;
